import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HeaderService } from './header.service';
import { NotificationComponent } from '../notification/notification.component';
import { Subscription } from 'rxjs';
import { NewLeadAlertComponent } from '../new-lead-alert/new-lead-alert.component';
import { SearchLeadService } from '../../core/search-lead/search-lead.service';
import { Location } from '@angular/common';
import { UserProfileService } from '../../core/user-profile/user-profile.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  dialogRef!: MatDialogRef<any>;
  isDropdownOpen = false;
  notifications: any = [

  ];

  constructor(private _location: Location, private toastr: ToastrService, private router: Router, public dialog: MatDialog, private cdr: ChangeDetectorRef, private headerService: HeaderService, private searchLeadService: SearchLeadService, private userService:UserProfileService) { }
  openDialog(logout_pop: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(logout_pop, {
      width: '400px',
    })
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  logOut() {
    this.dialogRef.close();
    sessionStorage.clear();
    this.router.navigate(['']);
    this.toastr.success('Logged out!');
    this.headerService.close();
  }


  toggleDropdown() {
    this.isDropdownOpen = true;
    this.cdr.detectChanges(); // Manually trigger change detection
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.notification-icon') || (event.target as HTMLElement).closest('.modal');
    if (!clickedInside) {
      this.closeDropdown();
    }
  }
  username: any = ''
  ngOnInit() {
     this.searchLeadService.userName$.subscribe((name:any) => {
        this.username = name;

    });
    setTimeout(() => {
      this.getMasters()
      this.getToDo();
    }, 100)
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.username = loginResponse.data?.user?.first_name + ' ' +
                (loginResponse.data?.user?.last_name ? loginResponse.data.user.last_name : '');
      }
    }
    this.connect();
    // this.webSocketConnectionCheck();
  }

  getMasters() {
    this.headerService.getMasters().subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        sessionStorage.setItem('masters', JSON.stringify(responseData.data));
      }
    })
  }

  openNotification() {
    const dialogRef = this.dialog.open(NotificationComponent, {
      // width: '650px',
      // height: '80vh' 
    });
  }

  notificationCount: any = 0
  getToDo() {
    this.headerService.getToDo().subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        this.notifications = response.body.data
        this.notifications = this.notifications.filter((data: any) => data.count != 0)
        this.notificationCount = this.notifications.length;
      } else {
        this.notifications = []
      }
    })
  }


  private leadDataSubscription!: Subscription;
  newLeadData: any = {};
  webSocketConnect() {
    this.headerService.connect();
    console.log("Subscribing to newLeadData...");
    this.leadDataSubscription = this.headerService.leadData.subscribe((data: any) => {
      console.log("Subscription triggered! Received data: ", data);
      this.newLeadData = data;
      if (this.newLeadData) {
        setTimeout(() => {
          console.log("open lead alert")
          this.openNewLeadModel();
        }, 100);
      }
    });
  }

  webSocketConnectionCheck() {
    this.headerService.closedData.subscribe((data: any) => {
      if (data == 'closed') {
        this.webSocketConnect();
      }
    });
  }

  openNewLeadModel() {
    const dialogRef = this.dialog.open(NewLeadAlertComponent, {
      data: this.newLeadData
    });
  }

  ngOnDestroy() {
    this.socket.close();
    clearInterval(this.pingInterval);
  }

  searchLeadText: any = ''
  searchLead() {
    if (this.searchLeadText) {
      this.router.navigate(['/suzuki/search-lead']);
      this.searchLeadService.changeData(this.searchLeadText)
    } else {
      this.toastr.error("Please enter a word to search!")
    }
  }

  clearText() {
    let url: any = this.router.url
    this.searchLeadText = '';
    if (url == '/suzuki/search-lead') {
      // this.router.navigate(['/suzuki/overview']);
      this._location.back();
    }
  }

  restrictFirstLetterSpace(event: any) {
    if (event.target.value.length == 0) {
      if (event.code === 'Space') {
        event.preventDefault();
      }
    }
  }

  isFocused: boolean = false;

  onFocus(): void {
    this.isFocused = true;
  }

  onBlur(): void {
    if (!this.searchLeadText && !this.isFocused) {
      this.isFocused = false;
    }
  }

  onMouseEnter(): void {
    if (!this.searchLeadText) {
      this.isFocused = true;
    }
  }

  onMouseLeave(): void {
    if (!this.searchLeadText) {
      this.isFocused = false;
    }
  }

  private socket!: WebSocket;
  private pingInterval!: any;
  connect(): void {
    let userId: any = '';
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        userId = loginResponse.data?.user?.id;
      }
    }
    if (userId) {
      if (!this.socket || this.socket.readyState == WebSocket.CLOSED) {
        this.socket = new WebSocket(environment.webSocketUrl + `?userId=${userId}`);
        console.log(`[${new Date().toLocaleTimeString()}] WebSocket connecting to:`, environment.webSocketUrl + `?userId=${userId}`);
      } 
    }  

    this.socket.onopen = () => {
      console.warn('WebSocket connection opened');
      // Start sending pings every 30 seconds
      this.pingInterval = setInterval(() => {
        if (this.socket.readyState === WebSocket.OPEN) {
          this.socket.send(JSON.stringify({ type: 'ping' }));
        }
      }, 30000);
    };

    this.socket.onmessage = (event) => {
      console.log(`Message from server [${new Date().toLocaleTimeString()}]:`, event.data);
      try {
        let serverData: any = JSON.parse(event.data); // Ensure JSON parsing if needed
        setTimeout(() => {
          this.newLeadData = serverData;
          if (this.newLeadData && Object.keys(this.newLeadData).length > 0) {
              console.log("open lead alert")
              this.openNewLeadModel();
          }
          console.log('Emit triggered with data:', serverData);
        }, 100);
      } catch (error) {
        console.error('Invalid JSON received:', event.data, error);
      }
    };
    

    this.socket.onerror = (error) => {
      console.error('WebSocket error: ', error);
    };

    this.socket.onclose = () => {
      console.log(`[${new Date().toLocaleTimeString()}] WebSocket connection closed`);
      clearInterval(this.pingInterval);
      this.connect();
    };
  }
}
